<template>
  <div class="activity_details_index">
    <div class="pt40">
      <components :is="activeCom" />
    </div>
  </div>  
</template>
<script>
import shareItem from './components/sharedetails';
import dealItem from './components/dealdetails';
import dealPrize from './components/dealprize';
import sharePrize from './components/shareprize';
import departmentBees from './components/departmentbees';
import branchBees from './components/branchbees';
export default {
  data(){
    return {
      activeCom:'branchBees'
    }
  },
  created(){
    this.$loading.hide();
  },
  mounted(){
    switch(this.$route.query.type){
      case 'shareItem':
        document.title ='分享明细';
        break;
      case 'dealItem':
        document.title ='成交明细';
        break;
      case 'dealPrize':
        document.title ='分享奖品清单';
        break;
      case 'sharePrize':
        document.title ='成交奖品清单';
        break;
      case 'departmentBees':
        document.title ='蜜蜂分享PK赛';
        break;
      case 'branchBees':
        document.title ='店铺情况';
        break;
    }
  },
  components:{
    'shareItem':shareItem,
    'dealItem':dealItem,
    'dealPrize':dealPrize,
    'sharePrize':sharePrize,
    'departmentBees':departmentBees,
    'branchBees':branchBees
  }
}
</script>
<style lang="less" scoped>
  .activity_details_index{
    background: #FEBC2E;
    width: 100%;
    height: 100%;
    .pt40{
      padding-top: 40px;
    }
  }
</style>